<template>
    <vx-expandable-card>
        <template v-slot:header> Audience Type </template>
        <template v-slot:headerSubtitle>
            You won't be able to edit this option later. If you need to change the audience type, you will need to
            duplicate the segment and select a new audience.
        </template>

        <template v-slot:content>
            <div class="mt-2">
                <audience-type-radio-selection
                    :modelValue="props.modelValue"
                    @update:modelValue="emit('update:modelValue', $event)"
                    :disabled="props.disabled"
                    :options="
                        props.templateView || !onCorporate()
                            ? [AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL]
                            : undefined
                    "
                >
                </audience-type-radio-selection>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard } from '@voxie/frontend-components';
import AudienceTypeRadioSelection from '../../../general/segments/AudienceTypeRadioSelection.vue';
import { AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL } from '~/constants/campaign';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const { onCorporate } = useCurrentGroup();

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
    },
    templateView: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);
</script>
